/** Уровни по порогам RP из Game Config (не строковые ярлыки редактора). */

const TIER_NAMES = ['Neutral', 'Trusting', 'Obedient', 'Devoted'];

export function relationshipTierIndex(rp, cfg) {
  const t = Number(rp) || 0;
  const trust = Number(cfg?.trustingThreshold) ?? 10;
  const obey = Number(cfg?.obedientThreshold) ?? 20;
  const dev = Number(cfg?.devotedThreshold) ?? 30;
  if (t < trust) return 0;
  if (t < obey) return 1;
  if (t < dev) return 2;
  return 3;
}

export function relationshipTierLabel(tierIndex) {
  return TIER_NAMES[Math.max(0, Math.min(3, tierIndex))] ?? TIER_NAMES[0];
}

export function nextRpMilestone(rp, tier, cfg) {
  const trust = Number(cfg?.trustingThreshold) || 10;
  const obey = Number(cfg?.obedientThreshold) || 20;
  const dev = Number(cfg?.devotedThreshold) || 30;
  if (tier >= 3) return Math.max(Number(rp) || 0, dev);
  if (tier === 0) return trust;
  if (tier === 1) return obey;
  return dev;
}

export function relationshipLeveledUp(rpBefore, rpAfter, cfg) {
  const a = relationshipTierIndex(rpBefore, cfg);
  const b = relationshipTierIndex(rpAfter, cfg);
  return b > a;
}
